import React, { Component } from "react";
import ProductCard from "../../customComponents/productCard/productCard";
import { Button, CircularProgress, Divider, Grid, Breadcrumbs, Typography, Pagination, Link as LinkMui } from "@mui/material";
import { Link, useParams } from "react-router-dom";
import { Product } from "../../../classes/types/product/product";
import { ProductHandler } from "../../../classes/methods/productMethods/productMethods";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBoxOpen } from "@fortawesome/free-solid-svg-icons/faBoxOpen";
import FilterPage from "../../customComponents/filterPage/filterPage";

interface Props {
  page?: string;
  loading?: boolean;
}

interface State {
  loading: boolean;
  products: Product[];
  pageProducts: Product[];
  currentPage: number;
  pageNumber: number;
  numberProductsInPage: number;
  productsToView: Product[];
  isLogged: boolean;
}

class Shop extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      products: [],
      pageProducts: [],
      numberProductsInPage: 20,
      currentPage: props.page ? Number(props.page) : 1,
      pageNumber: 1,
      loading: props.loading || false,
      productsToView: [],
      isLogged: false,
    };
  }

  componentDidMount() {
    this.refreshData();
  }

  componentDidUpdate(prevProps: Readonly<Props>) {
    if (prevProps.page !== this.props.page) {
      this.refreshData();
    }
  }

  refreshData = () => {
    this.setState({ loading: true });
    ProductHandler.getProducts()
      .then((newProducts) => {
        if (newProducts) {
          const newPageNumber = Math.ceil(newProducts.length / this.state.numberProductsInPage);
          const startingProduct = this.props.page
            ? (Number(this.props.page) - 1) * this.state.numberProductsInPage
            : 0;
          const lastProduct = startingProduct + this.state.numberProductsInPage;

          // Sanity check per pagina
          if (
            this.props.page &&
            (Number(this.props.page) <= 0 ||
              Number(this.props.page) > newPageNumber ||
              isNaN(Number(this.props.page)))
          ) {
            this.onPageChange(1);
          } else {
            this.setState({
              products: newProducts,
              pageProducts: newProducts.slice(startingProduct, lastProduct),
              pageNumber: newPageNumber,
              loading: false,
              productsToView: newProducts,
              isLogged: this.isLogged(newProducts),
            });
          }
        }
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  isLogged = (products: Product[]) => products.some((p) => !p.configurable && p.price !== undefined);

  onPageChange = (page: number) => {
    const newProductsPage = this.state.productsToView.slice(
      (page - 1) * this.state.numberProductsInPage,
      page * this.state.numberProductsInPage
    );
    window.history.replaceState(null, "GIGABYTE DISTRIBUZIONE", `/shop/page/${page}`);
    this.setState({ pageProducts: newProductsPage, currentPage: page });
  };

  onProductsFiltered = (newProductsToView: Product[]) => {
    const newPageNumber = Math.ceil(newProductsToView.length / this.state.numberProductsInPage);
    const newProductsPage = newProductsToView.slice(0, this.state.numberProductsInPage);
    window.history.replaceState(null, "GIGABYTE DISTRIBUZIONE", `/shop/page/1`);
    this.setState({
      productsToView: newProductsToView,
      pageProducts: newProductsPage,
      pageNumber: newPageNumber,
      currentPage: 1,
    });
  };

  render() {
    const { loading, products, pageProducts, currentPage, pageNumber, isLogged } = this.state;

    return (
      <Grid container spacing={2}>
        {/* Sidebar */}
        <Grid item xs={2}>
          <div style={{ backgroundColor: "white", position: "sticky", top: 0, paddingTop: 10 }}>
            {/* Breadcrumbs */}
            <Breadcrumbs aria-label="breadcrumb" style={{ paddingLeft: "8px" }}>
              <LinkMui component={Link} to="/" underline="hover" color="inherit">
                HOME
              </LinkMui>
              <Typography color="textPrimary">CATALOGO</Typography>
            </Breadcrumbs>

       

            {/* Filters */}
            <FilterPage isLogged={isLogged} products={products} loading={loading} onProductsFiltered={this.onProductsFiltered} />
          </div>
        </Grid>

        {/* Main content */}
        <Grid item xs={10}>
          {loading ? (
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "80vh" }}>
              <CircularProgress />
            </div>
          ) : products.length < 1 ? (
            <div style={{ marginTop: "10%", textAlign: "center" }}>
              <FontAwesomeIcon style={{ color: "grey", fontSize: "10vw" }} icon={faBoxOpen} />
              <h1>Nessun Prodotto Trovato</h1>
              <Button component={Link} to="/" variant="contained" color="primary">
                Ritorna alla Pagina Iniziale
              </Button>
            </div>
          ) : pageProducts.length < 1 ? (
            <div style={{ marginTop: "10%", textAlign: "center" }}>
              <FontAwesomeIcon style={{ color: "grey", fontSize: "10vw" }} icon={faBoxOpen} />
              <h1>Non Esistono Prodotti Con Queste Specifiche</h1>
            </div>
          ) : (
            <div style={{ padding: "0 16px", marginTop: 50 }} className="configurable-systems">
              <Divider style={{ marginBottom: 10 }} />
              {pageProducts.map((product, index) => (
                <><div key={index}>
                  <ProductCard
                    isLogged={isLogged}
                    linkName={`/shop/page/${currentPage}/prodotto/${product.id}`}
                    loading={loading}
                    product={product} />
                  <Divider style={{ marginBottom: 10 }} />
                </div><div style={{ marginTop: "16px", display: "flex", justifyContent: "center" }}>
                    <Pagination
                      count={pageNumber}
                      page={currentPage}
                      color="primary"
                      onChange={(e, page) => this.onPageChange(page)} />
                  </div></>
              ))}
                  
           
            </div>
            
          )}
        </Grid>
      </Grid>
    );
  }
}

// Wrapper React Router v6
export default function ShopWrapper() {
  const { page } = useParams<{ page?: string }>();
  return <Shop page={page} loading={true} />;
}
